import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
const Wrapper = styled.div `
    padding: 0 10px;

    .react-loading-skeleton {
        margin-bottom: 13px;
    }
`;
const SkeletonTableRow = () => {
    return (_jsx(Wrapper, { children: _jsx(Skeleton, { count: 5, height: 40 }) }));
};
export default SkeletonTableRow;
